import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18.572 9.208H4.877l3.276-3.44c.136-.138.245-.303.32-.486A1.56 1.56 0 0 0 8.17 3.63a1.4 1.4 0 0 0-.469-.328 1.37 1.37 0 0 0-1.105.01 1.4 1.4 0 0 0-.463.336l-5.714 6a1.5 1.5 0 0 0-.31.486 1.57 1.57 0 0 0 0 1.15q.108.275.31.487l5.714 5.998c.269.274.63.425 1.004.421a1.4 1.4 0 0 0 .998-.439c.265-.278.415-.654.418-1.047a1.54 1.54 0 0 0-.4-1.055l-3.276-3.442h13.694c.378 0 .742-.158 1.01-.44.267-.28.418-.662.418-1.06 0-.397-.15-.779-.418-1.06a1.4 1.4 0 0 0-1.01-.44z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }